import { render } from "./create-invoice.vue?vue&type=template&id=3a22f065&scoped=true"
import script from "./create-invoice.vue?vue&type=script&lang=js"
export * from "./create-invoice.vue?vue&type=script&lang=js"

import "./create-invoice.vue?vue&type=style&index=0&id=3a22f065&lang=css"
import "./create-invoice.vue?vue&type=style&index=1&id=3a22f065&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a22f065"]])

export default __exports__